import {
    Container,
    Form,
    Button,
    Row,
    Col
  } from "react-bootstrap";
  
  import { useNavigate, useLocation } from "react-router-dom";
  
 



import * as VhfLang from "../VhfLang"
  
import { useState,useEffect  } from "react";
import ApiHelper from "../../../helper/ApiHelper"
import Loader from "../../../helper/Loader"
import StepperHelper from "../../../helper/stepperHelper/StepperHelper"
import GetTokenHelper from "../../../helper/GetTokenHelper"
import GetRow from "./GetRow"
import ReadConfigHelper from "../../../helper/ReadConfigHelper"
import ConvertBoolToYesNoStringHelper from "../../../helper/ConvertBoolToYesNoStringHelper"

  
  const Preview = () => {
    
    const {state} = useLocation();
    const navigate = useNavigate();

    const [config,setConfig]=useState();
    const [hasError,setHasError]=useState(false);
    const [loading,setLoading]=useState(false);
  
  
    var privateContact=JSON.parse(sessionStorage.getItem(VhfLang.KeyForSessionForPrivateContact));
    var companyContact=JSON.parse(sessionStorage.getItem(VhfLang.KeyForSessionForCompanyContact));
    var specialPostAddressId=sessionStorage.getItem(VhfLang.SpecialPostAddressId)==='true';
    var shipInfo=JSON.parse(sessionStorage.getItem(VhfLang.KeyForSessionForShipInfo));
    var shipClassId=sessionStorage.getItem(VhfLang.ShipClassId);
    var isPrivateContact=sessionStorage.getItem(VhfLang.IsPrivateContact)=='true';
    var InvoiceChkId=sessionStorage.getItem(VhfLang.InvoiceAddressChkId)=='true';



    useEffect(() => {
      ReadConfigHelper(setConfig)
    },[])

var email=privateContact!=null?privateContact[VhfLang.EmailId]:(companyContact!=null?companyContact[VhfLang.EmailId]:"Ingen epost angiven!");
    if(privateContact==null&&companyContact==null){
      navigate(VhfLang.NavStartPage);
    }


const navigateToResult=(dayBookNo,emailResponse,email)=>{
  navigate(VhfLang.NavThanks,{
    state: {
      dayBookNo,
      emailResponse,
      email
    }},
    );
   
}

const saveToApi=(token)=>{
  var dataToSend={...privateContact,...companyContact,...shipInfo,shipClassId,isPrivateContact,InvoiceChkId};  
  ApiHelper(dataToSend,config.postToServerUrl,setHasError,token,config.AccessHeader,setLoading,navigateToResult,email);
}


const onSubmit=()=>{
  GetTokenHelper(config.getTokenUrl,config.AccessHeader,setHasError,setLoading,saveToApi);
}
const  backToStepOne=()=>{
     navigate(VhfLang.NavShipInfo
      );
  }
  
    if(loading){
        return <Loader startLoader={loading}></Loader>
      }
  
  
      return(
        <>
          <StepperHelper activeStep={3}></StepperHelper>

           {hasError&&<h1 className="text-danger">Något gick fel försök igen<br></br><br></br></h1>}
          <fieldset>
          <h2>{VhfLang.PreviewLegendH2}</h2>
           
         
          {privateContact!=null&&GetRow(VhfLang.ContactHeadlinePrivate,"",true)}
          
          {//private contact
          privateContact!=null&&GetRow("Namn",privateContact[VhfLang.FirstnameId]+" "+privateContact[VhfLang.LastnameId])}
          {privateContact!=null&& GetRow(VhfLang.SSNLabel,privateContact[VhfLang.SSNId])}

          {privateContact!=null&&GetRow(VhfLang.Address1Label,privateContact[VhfLang.Address1Id])}
          {privateContact!=null&&GetRow(VhfLang.Address2Label,privateContact[VhfLang.Address2Id])}

          {privateContact!=null&&GetRow(VhfLang.ZipcodeLabel,privateContact[VhfLang.ZipcodeId])}
          {privateContact!=null&&GetRow(VhfLang.CityLabel,privateContact[VhfLang.CityId])}
          {privateContact!=null&&GetRow(VhfLang.CountryLabel,privateContact[VhfLang.CountryId])}
          {privateContact!=null&&GetRow(VhfLang.PhoneLabel,privateContact[VhfLang.PhoneId])}
          {privateContact!=null&&GetRow(VhfLang.EmailLabel,privateContact[VhfLang.EmailId])}
         
          {specialPostAddressId!=null&&  isPrivateContact&&ConvertBoolToYesNoStringHelper(VhfLang.SpecialPostAddressPreview,specialPostAddressId)}
          


          {companyContact!=null&&GetRow(VhfLang.ContactHeadlineCompany,"",true)}
        {companyContact!=null && GetRow(VhfLang.CompanyLabel,companyContact[VhfLang.CompanyId])}
        {companyContact!=null && GetRow(VhfLang.OrgNoLabel,companyContact[VhfLang.OrgNoId])}
        {companyContact!=null && GetRow(VhfLang.ContactLabel,companyContact[VhfLang.ContactId])}
          
          {companyContact!=null && GetRow(VhfLang.Address1Label,companyContact[VhfLang.Address1Id])}
          {companyContact!=null && GetRow(VhfLang.Address2Label,companyContact[VhfLang.Address2Id])}

          {companyContact!=null &&GetRow(VhfLang.ZipcodeLabel,companyContact[VhfLang.ZipcodeId])}
          {companyContact!=null &&GetRow(VhfLang.CityLabel,companyContact[VhfLang.CityId])}
          {companyContact!=null &&GetRow(VhfLang.CountryLabel,companyContact[VhfLang.CountryId])}
          {companyContact!=null &&GetRow(VhfLang.PhoneLabel,companyContact[VhfLang.PhoneId])}
          {companyContact!=null &&GetRow(VhfLang.EmailLabel,companyContact[VhfLang.EmailId])}

          {companyContact!=null&&GetRow(<br/>,"",true)}
          {companyContact!=null&&companyContact[VhfLang.InvoiceZipcodeId]&&GetRow(VhfLang.ContactInvoiceCompany,"",true)}
          {companyContact!=null &&GetRow(VhfLang.InvoiceAddress1Label,companyContact[VhfLang.InvoiceAddress1Id])}
          {companyContact!=null &&GetRow(VhfLang.InvoiceAddress2Label,companyContact[VhfLang.InvoiceAddress2Id])}
          {companyContact!=null &&GetRow(VhfLang.InvoiceRefLabel,companyContact[VhfLang.InvoiceRefId])}

          {companyContact!=null &&GetRow(VhfLang.InvoiceCityLabel,companyContact[VhfLang.InvoiceCityId])}
          {companyContact!=null &&GetRow(VhfLang.InvoiceZipcodeLabel,companyContact[VhfLang.InvoiceZipcodeId])}
          {companyContact!=null &&GetRow(VhfLang.InvoiceCountryLabel,companyContact[VhfLang.InvoiceCountryId])}
          

          {shipInfo!=null&&GetRow(<br/>,"",true)}
            {shipInfo!=null&&GetRow(VhfLang.ShipInfoHeadline,"",true)}
          {shipClassId!=null &&GetRow(VhfLang.ShipClassLabel,shipClassId)}
          {shipClassId!=null &&GetRow(VhfLang.DistrictLabel,shipInfo[VhfLang.DistrictId])}
          {shipClassId!=null &&GetRow(VhfLang.CallsignLabel,shipInfo[VhfLang.CallsignId])}

          {shipInfo!=null &&GetRow(VhfLang.ShipNameLabelLang,shipInfo[VhfLang.ShipNameId])}
          {shipInfo!=null &&GetRow(VhfLang.BoatSizeLengthLang,shipInfo[VhfLang.BoatSizeLengthId])}
          
          {shipInfo!=null &&GetRow(VhfLang.HandheldCheckBoxLabel,shipInfo[VhfLang.HandheldCheckBoxId])}
<br></br>
          {shipInfo!=null &&GetRow(VhfLang.MmsiCheckboxLabel,shipInfo[VhfLang.MmsiId],undefined,true)}
          {shipInfo!=null &&GetRow(VhfLang.AISCheckboxLabel,shipInfo[VhfLang.AISCheckboxId],undefined,true)}
          {shipInfo!=null &&GetRow(VhfLang.EpirbCheckboxLabel406,shipInfo[VhfLang.Epirb406Id],undefined,true)}
          {shipInfo!=null &&GetRow(VhfLang.EpirbCheckbox1215IdLabel,shipInfo[VhfLang.Epirb1215Id],undefined,true)}

          {(shipInfo[VhfLang.Epirb1215Id]||shipInfo[VhfLang.Epirb406Id])&&<>{VhfLang.ShouldRegisterSjoFartverket}</>}

          {shipInfo!=null &&   isPrivateContact&&<><br></br>{ConvertBoolToYesNoStringHelper(VhfLang.UseForMarketingLabel,shipInfo[VhfLang.UseForMarketingId],true)}</>}
          {
          shipInfo!=null &&<><br></br>{GetRow(VhfLang.CommentPreviewLabel,shipInfo[VhfLang.CommentId])}<br></br></>}
          {companyContact!=null&&GetRow(<br/>,"",true)}
        
          <div className="float-end">
            <Button variant="back"  onClick={backToStepOne}  className="button-margin" >
              {VhfLang.ButtonPreviousDisplay}
            </Button>
    
            <Button variant="next"  onClick={onSubmit} className="button-margin" disabled={loading&&!hasError} >
              {VhfLang.ButtonSendDisplay}
            </Button>
          </div>

          </fieldset>
       
          </>
      );
  
  }
  export default Preview
  
  //{getRow("Namn (Förnamn efternamn)",state.values.firstname+" "+state.values.lastname)}
  //{shipInfo!=null &&GetRow(VhfLang.BoatSizeWidthLang,shipInfo[VhfLang.BoatSizeWidthId])}